import React from 'react';
import { Container } from './ui/Container';
export function ProductInUseSection() {
  return <section className="py-16 bg-gray-900 text-white relative overflow-hidden" data-id="element-440">
      <div className="absolute inset-0 bg-blue-900/20" data-id="element-441"></div>
      <Container className="relative z-10" data-id="element-442">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-443">
          <div data-id="element-444">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-445">
              Simple to Use, Impossible to Ignore
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-446">
              Mold it to your teeth in 60 seconds. Wear it at night. Wake up to
              silence and a grateful partner.
            </p>
            <ul className="space-y-4" data-id="element-447">
              <li className="flex items-center text-gray-200" data-id="element-448">
                <span className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-3 font-bold" data-id="element-449">
                  1
                </span>
                Dip in warm water to soften
              </li>
              <li className="flex items-center text-gray-200" data-id="element-450">
                <span className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-3 font-bold" data-id="element-451">
                  2
                </span>
                Bite down to create custom mold
              </li>
              <li className="flex items-center text-gray-200" data-id="element-452">
                <span className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-3 font-bold" data-id="element-453">
                  3
                </span>
                Sleep peacefully
              </li>
            </ul>
          </div>
          <div className="relative" data-id="element-454">
            <img src="https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png" alt="Product in use" className="w-full max-w-md mx-auto drop-shadow-[0_0_30px_rgba(59,130,246,0.5)]" data-id="element-455" />
          </div>
        </div>
      </Container>
    </section>;
}